import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Instagram, Facebook, Phone, Mail, MapPin } from 'lucide-react';

const Footer3 = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');

    const handleSubscribe = (e) => {
        e.preventDefault();
        if (email.trim()) {
            setEmail('');
        }
    };

    const collectionsLinks = [
        { label: 'Bridal Lehengas', path: '/template3/shop' },
        { label: 'Silk Sarees', path: '/template3/shop' },
        { label: 'Sherwanis', path: '/template3/shop' },
        { label: 'Festive Wear', path: '/template3/shop' },
        { label: 'Heritage Collection', path: '/template3/shop' },
    ];

    const customerCareLinks = [
        { label: 'Contact Us', path: '/template3/contact' },
        { label: 'Shipping Policy', path: '/template3/shipping-exchange' },
        { label: 'Returns & Exchange', path: '/template3/shipping-exchange' },
        { label: 'FAQs', path: '/template3/faqs' },
        { label: 'Track Order', path: '/template3/orders' },
    ];

    const legalLinks = [
        { label: 'Terms & Conditions', path: '/template3/terms' },
        { label: 'Privacy Policy', path: '/template3/privacy-policy' },
    ];

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;500;600;700&family=Lato:wght@300;400;700&display=swap');
                .vastra-footer-grid {
                    display: grid;
                    grid-template-columns: 1fr;
                    gap: 40px;
                }
                @media (min-width: 768px) {
                    .vastra-footer-grid {
                        grid-template-columns: 1.5fr 1fr 1fr 1fr;
                        gap: 48px;
                    }
                }
            `}</style>

            <footer style={{ backgroundColor: '#722F37', borderTop: '4px solid #B8860B' }}>
                {/* Main Footer Content */}
                <div
                    style={{
                        maxWidth: '1400px',
                        margin: '0 auto',
                        padding: '64px 24px',
                    }}
                >
                    <div className="vastra-footer-grid">
                        {/* Column 1: Brand */}
                        <div>
                            <h3
                                style={{
                                    fontFamily: "'Playfair Display', serif",
                                    fontSize: '32px',
                                    fontWeight: 700,
                                    color: '#FFFFFF',
                                    letterSpacing: '3px',
                                    margin: '0 0 16px 0',
                                }}
                            >
                                VASTRA
                            </h3>
                            <p
                                style={{
                                    fontFamily: "'Lato', sans-serif",
                                    fontSize: '14px',
                                    color: 'rgba(255,255,255,0.7)',
                                    lineHeight: 1.7,
                                    margin: '0 0 24px 0',
                                    fontStyle: 'italic',
                                }}
                            >
                                Royal Indian Couture — Where Heritage Meets Elegance
                            </p>
                            <div style={{ display: 'flex', gap: '12px' }}>
                                {[Instagram, Facebook].map((Icon, i) => (
                                    <a
                                        key={i}
                                        href="#"
                                        style={{
                                            width: '40px',
                                            height: '40px',
                                            border: '1px solid rgba(255,255,255,0.25)',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            color: '#B8860B',
                                            transition: 'all 0.3s ease',
                                            textDecoration: 'none',
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.borderColor = '#B8860B';
                                            e.currentTarget.style.backgroundColor = 'rgba(184,134,11,0.15)';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.borderColor = 'rgba(255,255,255,0.25)';
                                            e.currentTarget.style.backgroundColor = 'transparent';
                                        }}
                                    >
                                        <Icon size={18} />
                                    </a>
                                ))}
                            </div>
                        </div>

                        {/* Column 2: Collections */}
                        <div>
                            <h4
                                style={{
                                    fontFamily: "'Playfair Display', serif",
                                    fontSize: '16px',
                                    fontWeight: 600,
                                    color: '#B8860B',
                                    letterSpacing: '2px',
                                    textTransform: 'uppercase',
                                    margin: '0 0 20px 0',
                                }}
                            >
                                Collections
                            </h4>
                            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '12px' }}>
                                {collectionsLinks.map((link, i) => (
                                    <li key={i}>
                                        <button
                                            onClick={() => navigate(link.path)}
                                            style={{
                                                fontFamily: "'Lato', sans-serif",
                                                fontSize: '14px',
                                                color: 'rgba(255,255,255,0.7)',
                                                background: 'none',
                                                border: 'none',
                                                cursor: 'pointer',
                                                padding: 0,
                                                transition: 'color 0.3s ease',
                                            }}
                                            onMouseEnter={(e) => (e.target.style.color = '#B8860B')}
                                            onMouseLeave={(e) => (e.target.style.color = 'rgba(255,255,255,0.7)')}
                                        >
                                            {link.label}
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Column 3: Customer Care */}
                        <div>
                            <h4
                                style={{
                                    fontFamily: "'Playfair Display', serif",
                                    fontSize: '16px',
                                    fontWeight: 600,
                                    color: '#B8860B',
                                    letterSpacing: '2px',
                                    textTransform: 'uppercase',
                                    margin: '0 0 20px 0',
                                }}
                            >
                                Customer Care
                            </h4>
                            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '12px' }}>
                                {customerCareLinks.map((link, i) => (
                                    <li key={i}>
                                        <button
                                            onClick={() => navigate(link.path)}
                                            style={{
                                                fontFamily: "'Lato', sans-serif",
                                                fontSize: '14px',
                                                color: 'rgba(255,255,255,0.7)',
                                                background: 'none',
                                                border: 'none',
                                                cursor: 'pointer',
                                                padding: 0,
                                                transition: 'color 0.3s ease',
                                            }}
                                            onMouseEnter={(e) => (e.target.style.color = '#B8860B')}
                                            onMouseLeave={(e) => (e.target.style.color = 'rgba(255,255,255,0.7)')}
                                        >
                                            {link.label}
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Column 4: Contact */}
                        <div>
                            <h4
                                style={{
                                    fontFamily: "'Playfair Display', serif",
                                    fontSize: '16px',
                                    fontWeight: 600,
                                    color: '#B8860B',
                                    letterSpacing: '2px',
                                    textTransform: 'uppercase',
                                    margin: '0 0 20px 0',
                                }}
                            >
                                Get in Touch
                            </h4>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                    <Phone size={16} style={{ color: '#B8860B', flexShrink: 0 }} />
                                    <span style={{ fontFamily: "'Lato', sans-serif", fontSize: '14px', color: 'rgba(255,255,255,0.7)' }}>
                                        +91 98765 43210
                                    </span>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                    <Mail size={16} style={{ color: '#B8860B', flexShrink: 0 }} />
                                    <span style={{ fontFamily: "'Lato', sans-serif", fontSize: '14px', color: 'rgba(255,255,255,0.7)' }}>
                                        hello@vastra.com
                                    </span>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                                    <MapPin size={16} style={{ color: '#B8860B', flexShrink: 0, marginTop: '2px' }} />
                                    <span style={{ fontFamily: "'Lato', sans-serif", fontSize: '14px', color: 'rgba(255,255,255,0.7)', lineHeight: 1.6 }}>
                                        Heritage Lane, Jaipur,<br />Rajasthan 302001
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Bottom Bar */}
                <div
                    style={{
                        borderTop: '1px solid rgba(255,255,255,0.15)',
                        padding: '20px 24px',
                    }}
                >
                    <div
                        style={{
                            maxWidth: '1400px',
                            margin: '0 auto',
                            display: 'flex',
                            flexWrap: 'wrap',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            gap: '12px',
                        }}
                    >
                        <p style={{ fontFamily: "'Lato', sans-serif", fontSize: '12px', color: 'rgba(255,255,255,0.5)', margin: 0 }}>
                            &copy; {new Date().getFullYear()} VASTRA. All rights reserved.
                        </p>
                        <div style={{ display: 'flex', gap: '24px' }}>
                            {legalLinks.map((link, i) => (
                                <button
                                    key={i}
                                    onClick={() => navigate(link.path)}
                                    style={{
                                        fontFamily: "'Lato', sans-serif",
                                        fontSize: '12px',
                                        color: 'rgba(255,255,255,0.5)',
                                        background: 'none',
                                        border: 'none',
                                        cursor: 'pointer',
                                        padding: 0,
                                        transition: 'color 0.3s ease',
                                    }}
                                    onMouseEnter={(e) => (e.target.style.color = '#B8860B')}
                                    onMouseLeave={(e) => (e.target.style.color = 'rgba(255,255,255,0.5)')}
                                >
                                    {link.label}
                                </button>
                            ))}
                        </div>
                    </div>
                </div>
            </footer>
        </>
    );
};

export default Footer3;
